import { Table } from 'shared/ui/Table';
import type { HistoryModels, HistoryTableColumns } from 'entities/history';

interface HistoryTableProps {
  history: HistoryModels[] | undefined;
  columns: HistoryTableColumns;
  isLoading: boolean;
}

export function HistoryTable(props: HistoryTableProps) {
  const { history, columns, isLoading } = props;

  return (
    <div className="pb-5">
      <Table
        hasRowCursorPointer
        variant="table-sm"
        columns={columns}
        data={history}
        isLoading={isLoading}
        rowKey={(data) => `${data.createdAt} ${data.eventType}`}
      />
    </div>
  );
}
